import { Badge } from "react-bootstrap"
import IconText from "ui/components/IconText"
import { ENERGIZED_ICON, SUCCESS_ICON } from "ui/icons"
import { getExecutionStatus } from "./index.js"

export type StatusBadgeProps = ReturnType<typeof getExecutionStatus>

export default function StatusBadge(props: StatusBadgeProps) {
    return (
        <Badge bg={props.allLockedOut ? "success" : "danger"}>
            <IconText {...(props.allLockedOut ? SUCCESS_ICON : ENERGIZED_ICON)}>
                {props.allLockedOut ? "Locked Out" : props.allEnergized ? "Energized" : "Partially Energized"}
            </IconText>
        </Badge>
    )
}
